import findAllFor from './find-all-for';
import findFirstFor from './find-first-for';

export default {
  findAllFor,
  findFirstFor,
};
